import { zaokr, zl } from "../../../functions/utilities";

const WodaOdczytyUdzialyProcentyTFoot = (props) => {
    
    const { wybraneRozliczenie } = props;
    const { zuzycieMZimna, zuzycieMCiepla, kosztZimnejRazem, abonamentRazem, kosztPodgrzaniaRazem, razemZwCwAboTotal, zaliczkaZimnaTotal, zaliczkaCieplaTotal, zaliczkaAbonament, zaliczkaTotal, strataTotal, saldoTotal, strata, metrazRazem } = wybraneRozliczenie || {};
    return (
        <tfoot> 
            <tr>
                <td colSpan={2}> 
                    Razem
                </td>
                <td>
                    {`${zaokr(metrazRazem)} m²`}
                </td>
                <td colSpan={2}></td>
                <td>
                    {`${zuzycieMZimna || '-'} m³`}
                </td>
                <td>
                    {`${zuzycieMCiepla || '-'} m³`}
                </td>
                <td>
                    {zl(kosztZimnejRazem)}
                </td>
                <td>
                    {zl(abonamentRazem)}
                </td>
                <td>
                    {zl(kosztPodgrzaniaRazem)}
                </td>
                <td>
                    {zl(razemZwCwAboTotal)}
                </td>
                <td>
                    {zl(zaliczkaZimnaTotal)}
                </td>
                <td>
                    {zl(zaliczkaAbonament)}
                </td>
                <td>
                    {zl(zaliczkaCieplaTotal)}
                </td>
                <td>
                    {zl(zaliczkaTotal)}
                </td>
                <td>
                    {zl(strataTotal)}
                </td>
                <td>
                    {`${strata || '-'} m³`}
                </td>
                <td>
                    {zl(saldoTotal)}
                </td>
            </tr>
        </tfoot>
    )
}

export default WodaOdczytyUdzialyProcentyTFoot;